import React, { useState, useContext } from "react";
import { AppContext } from "./ContextVars";
import translations from "./translations";

const BankApprovals = () => { // #added página admin para aprobar Transferencias Bancarias 1/8/26 TG
  const { language } = useContext(AppContext);
  const t = (key) => translations.BankAdmin[key]?.[language] || key;

  const [passphrase, setPassphrase] = useState(sessionStorage.getItem("bankAdminPass") || "");
  const [entered, setEntered] = useState(sessionStorage.getItem("bankAdminPass") || "");
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [actioning, setActioning] = useState("");

  const load = async (pass) => {
    setLoading(true);
    setError("");
    try {
      const res = await fetch("https://eleven.fit/php/bank-get-pending.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ passphrase: pass }),
      });
      const data = await res.json();
      if (data.success) {
        setOrders(data.data || []);
      } else {
        setError(data.message || t("loadError"));
      }
    } catch (e) {
      setError(t("networkError"));
    }
    setLoading(false);
  };

  const handleLogin = (e) => {
    e.preventDefault();
    sessionStorage.setItem("bankAdminPass", entered);
    setPassphrase(entered);
    load(entered);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("bankAdminPass");
    setPassphrase("");
    setEntered("");
    setOrders([]);
  };

  const approve = async (orderNumber) => {
    if (!window.confirm(t("confirmApprove") + " " + orderNumber)) return;
    setActioning(orderNumber);
    try {
      const res = await fetch("https://eleven.fit/php/bank-approve.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ passphrase, order: orderNumber }),
      });
      const data = await res.json();
      if (data.success) {
        load(passphrase);
      } else {
        alert(data.message || t("approveError"));
      }
    } catch (e) {
      alert(t("networkError"));
    }
    setActioning("");
  };

  if (!passphrase) {
    return (
      <section className="section overlay tint-black-40">
        <div className="section__content">
          <h2 className="general-title">{t("title")}</h2>
          <form onSubmit={handleLogin} className="max-width-70" style={{ margin: "0 auto" }}>
            <p className="margin-top-20">{t("passphrase")}</p>
            <input
              type="password"
              value={entered}
              onChange={(e) => setEntered(e.target.value)}
              className="w-full border mb-2 p-2"
              style={{ color: "#000" }}
            />
            <button className="button-2 margin-top-10" type="submit">
              {t("enter")}
            </button>
          </form>
          {error && <p className="margin-top-10 font-size-18 color-gray-3">{error}</p>}
        </div>
      </section>
    );
  }

  return (
    <section className="section overlay tint-black-40">
      <div className="section__content">
        <div className="max-width-70" style={{ margin: "0 auto" }}>
          <h2 className="general-title">{t("title")}</h2>
          <button className="button-2 margin-top-10" onClick={handleLogout}>
            {t("logout")}
          </button>
          <button className="button-2 margin-top-10" onClick={() => load(passphrase)}>
            {t("refresh")}
          </button>

          {loading && <p className="margin-top-20 font-size-20 color-gray-3">{t("loading")}</p>}
          {!loading && error && <p className="margin-top-20 font-size-20 color-gray-3">{error}</p>}
          {!loading && !error && orders.length === 0 && (
            <p className="margin-top-20 font-size-20 color-gray-3">{t("noOrders")}</p>
          )}

          {orders.map((o) => {
            const resp = o.response_data || {};
            return (
              <div key={o.order_number} className="margin-top-30" style={{ border: "1px solid rgba(255,255,255,0.3)", padding: "20px" }}>
                <p className="font-size-20 color-gray-3">
                  <strong>{t("orderNumber")}:</strong> {o.order_number}
                </p>
                <p className="font-size-20 color-gray-3">
                  <strong>{t("created")}:</strong> {o.created_at}
                </p>
                <p className="font-size-20 color-gray-3">
                  <strong>{t("customer")}:</strong> {o.first_name} {o.last_name} ({o.email})
                </p>
                <p className="font-size-20 color-gray-3">
                  <strong>{t("amount")}:</strong> {o.currency === "GTQ" ? "Q" : "$"}
                  {parseFloat(o.amount || 0).toFixed(2)} {o.currency}
                </p>
                {o.items && o.items.length > 0 && (
                  <p className="font-size-20 color-gray-3">
                    <strong>{t("items")}:</strong>{" "}
                    {o.items.map((it) => it.name || it.product_id).join(", ")}
                  </p>
                )}
                <p className="font-size-20 color-gray-3">
                  <strong>{t("status")}:</strong>{" "}
                  {o.status === "pending_approval" ? t("pendingApproval") : t("awaitingProof")}
                </p>

                {resp.bank_reference && (
                  <p className="font-size-20 color-gray-3">
                    <strong>{t("bankRef")}:</strong> {resp.bank_reference}
                  </p>
                )}
                {resp.proof_path && (
                  <p className="margin-top-10">
                    <a href={resp.proof_path} target="_blank" rel="noreferrer">
                      {t("viewProof")}
                    </a>
                    <br />
                    <img
                      src={resp.proof_path}
                      alt="proof"
                      style={{ maxWidth: "280px", marginTop: "10px", border: "1px solid #fff" }}
                    />
                  </p>
                )}

                {o.status === "pending_approval" && (
                  <button
                    className="button-2 margin-top-20"
                    disabled={actioning === o.order_number}
                    onClick={() => approve(o.order_number)}
                  >
                    {actioning === o.order_number ? t("approving") : t("approve")}
                  </button>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BankApprovals;
